import { Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import UserKycApprove from './UserKycApprove';
import SchoolKycApprove from './SchoolKycApprove';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box py={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
}));

function KycApproval() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box>
      <Box className={classes.root}>
        <Box>
          <Tabs
            TabIndicatorProps={{ style: { background: '#fe4500' } }}
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example">
            <Tab label="User KYC" {...a11yProps(0)} />
            <Tab label="School KYC" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <UserKycApprove />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <SchoolKycApprove />
        </TabPanel>
      </Box>
    </Box>
  );
}

export default KycApproval;
